import { IMedicalOrderPosition, IServiceDosage } from '@alberta/konexi-shared';

export class MedicalOrderPositionViewModel implements IMedicalOrderPosition {
  constructor() {}
  serviceId: string;
  name: string;
  description: string;
  startDate: string;
  endDate: string;
  dosage: IServiceDosage;
  quantity: number;
}
